import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, isRef as _isRef, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "space-y-8" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { class: "card-global flex divide-x" }
const _hoisted_4 = { class: "flex-1 space-y-6" }
const _hoisted_5 = { class: "flex space-x-12" }
const _hoisted_6 = {
  for: "user-phone-input",
  class: "input-form-label"
}
const _hoisted_7 = {
  key: 0,
  class: "input-form-error-text"
}
const _hoisted_8 = { class: "flex space-x-12" }
const _hoisted_9 = {
  for: "user-middle-name-input",
  class: "input-form-label"
}
const _hoisted_10 = {
  key: 0,
  class: "input-form-error-text"
}
const _hoisted_11 = { class: "flex space-x-12" }
const _hoisted_12 = {
  key: 0,
  class: "input-form-error-text"
}
const _hoisted_13 = {
  key: 0,
  class: "input-form-error-text"
}
const _hoisted_14 = {
  key: 0,
  class: "input-form-error-text"
}
const _hoisted_15 = {
  key: 1,
  class: "input-form-error-text"
}
const _hoisted_16 = { class: "card-global space-y-8 mt-8" }
const _hoisted_17 = { class: "grid grid-cols-6 gap-x-4" }
const _hoisted_18 = { class: "col-span-4 space-y-8" }
const _hoisted_19 = ["value"]
const _hoisted_20 = ["value"]
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "input-form-label" }
const _hoisted_23 = { value: "INTERNAL" }
const _hoisted_24 = { value: "EXTERNAL" }
const _hoisted_25 = { style: {"height":"440px","overflow-y":"scroll"} }

import { normalizeUserPhone, validUserPhone } from '@/utils/userPhone';
import BackButton from "@/components/common/BackButton.vue";
import { ref, onMounted, reactive, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import { Button, TextButton, SegmentedButtons } from "@/components/common/";
import { Company, User } from "@/types/";
import { useStore } from "vuex";
import Multiselect from "@vueform/multiselect";
import { StatusesEnum } from "@/store";
import {
  email,
  maxLength,
  minLength,
  required,
  numeric,
  helpers,
} from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import { UserActions } from "@/store/modules/user/actions";
import { UserGetters } from "@/store/modules/user/getters";
import { RoleActions } from "@/store/modules/role/actions";
import { JobActions } from "@/store/modules/job/actions";
import { CompanyActions } from "@/store/modules/company/actions";
import { RoleGetters } from "@/store/modules/role/getters";
import { JobGetters } from "@/store/modules/job/getters";
import { CompanyGetters } from "@/store/modules/company/getters";
import Modal from "@/components/common/Modal.vue";
import TreeListMulti from "@/components/common/TreeListMulti.vue";
import { t } from "@/i18n";
import { useToast } from "vue-toastification";
import EntityScopeFields from "@/components/common/EntityScopeFields.vue";
import {
  defaultScopeFields,
  withScopeFields,
  scopeFromEntity,
} from "@/utils/entityScope";
import { IScopeFields } from "@/types/common/entityApproval/EntityScope";
import { getCommonStatusLabel, getCommonStatusOptions } from "@/utils/labels";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const toast = useToast();
const route = useRoute();
const store = useStore();

const state = reactive<Omit<User, "jobName" | "companyName">>({
  login: "",
  email: "",
  phone: "",
  password: "",
  iin: "",
  status: StatusesEnum.ACTIVE,
  name: "",
  surname: "",
  middleName: "",
  job: null,
  company: null,
  roleIds: [],
  userType: "INTERNAL",
});
const statusOptions = computed(() => getCommonStatusOptions());
const statuses = computed(() => Object.values(statusOptions.value));
const selectedStatus = computed({
  get: () => getCommonStatusLabel(state.status) || state.status,
  set: (label: string) => {
    const status = Object.entries(statusOptions.value).find(
      ([, value]) => value === label
    )?.[0];
    state.status = status ?? label;
  },
});
const scopeFields = ref<IScopeFields>(defaultScopeFields());
const isCreateMode = computed(() => route.name !== "UserEdit");
const isPasswordRequired = computed(
  () => isCreateMode.value && state.userType !== "EXTERNAL"
);

const rules = computed(() => ({
  login: { required },
  email: { required, email },
  password: isPasswordRequired.value ? { required } : {},
  iin: {
    required,
    numeric: numeric,
    maxLength: maxLength(12),
    minLength: minLength(12),
  },
  status: { required },
  name: { required },
  surname: { required },
  middleName: {},
  job: { required },
  company: { required },
  roleIds: { required },
  userType: { required },
}));
const $externalResults = ref({});
const submitted = ref(false);
const v$ = useVuelidate(rules, state, { $externalResults });

const roles = ref();
const jobs = ref();

const image = ref("");
onMounted(async () => {
  await store.dispatch(RoleActions.FETCH_ALL);
  await store.dispatch(JobActions.FETCH_ALL);
  await store.dispatch(CompanyActions.FETCH_ALL);

  roles.value = store.getters[RoleGetters.GET_ALL];
  jobs.value = store.getters[JobGetters.GET_ALL];

  if (route.name === "UserEdit") {
    await store.dispatch(UserActions.FETCH_ONE, route.params.id);
    const user = store.getters[UserGetters.GET_CURRENT];
    state.id = user.id;
    state.login = user.login;
    state.email = user.email;
    state.phone = user.phone || '';
    state.password = user.password;
    state.iin = user.iin;
    state.status = user.status;
    state.name = user.name;
    state.surname = user.surname;
    state.middleName = user.middleName;
    state.job = user.job;
    state.company = user.company;
    state.roleIds = user.roleIds;
    state.userType = user.userType ?? "INTERNAL";
    scopeFields.value = scopeFromEntity(user);
  }
});

const companies = computed(() => {
  return store.getters[CompanyGetters.GET_ALL];
});

const directorateOptions = computed(() =>
  (companies.value ?? []).map((c: Company) => ({
    id: c.id!,
    name: c.name,
  }))
);

async function handleSubmit(isFormValid: boolean) {
  submitted.value = true;
  if (!isFormValid || !phoneValid.value) {
    return;
  }

  route.name === "UserEdit" ? await updateUser() : await createUser();
}

const normalizedPhone = computed(() => normalizeUserPhone(state.phone));
const phoneValid = computed(() => validUserPhone(state.phone));
const buildUserPayload = () => withScopeFields({ ...state, phone: normalizedPhone.value || null }, scopeFields.value);

const createUser = async () => {
  await store
    .dispatch(UserActions.CREATE, buildUserPayload())
    .then(async () => {
      toast.success(t("approval.submitted"));
      await router.push({ name: "UserList" });
    })
    .catch((error) => {
      $externalResults.value = error.data.data;
      toast.error(t("approval.submitError"));
    });
};

const updateUser = async () => {
  await store
    .dispatch(UserActions.UPDATE, { id: state.id, data: buildUserPayload() })
    .then(async () => {
      toast.success(t("approval.submitted"));
      await router.push({ name: "UserList" });
    })
    .catch((error) => {
      console.error(error);
      toast.error(t("approval.submitError"));
    });
};

async function handleTreeListSelect(data: Company) {
  state.company = data.id || 0;
}

const isShowCompanyModal = ref(false);
const companyName = computed(() => {
  const company: Company | undefined = companies.value.find(
    (item: Company) => item.id === state.company
  );

  return company ? company.name : t("common.notSelected");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BackButton, {
      to: { name: 'UserList' },
      class: "mb-4"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$route.name === "UserEdit"
          ? _unref(t)("userForm.titleEdit")
          : _unref(t)("userForm.titleCreate")) + " " + _toDisplayString(_unref(t)("userForm.user")), 1),
      _createElementVNode("form", {
        onSubmit: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (handleSubmit(!_unref(v$).$invalid)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, [
                _createElementVNode("label", {
                  for: "user-name-input",
                  class: _normalizeClass(["input-form-label", { 'p-error': _unref(v$).name.$invalid && submitted.value }])
                }, _toDisplayString(_unref(t)("common.name")), 3),
                _withDirectives(_createElementVNode("input", {
                  id: "user-name-input",
                  type: "text",
                  class: _normalizeClass(["input-form", {
                  'p-invalid': _unref(v$).name.$invalid && submitted.value,
                }]),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).name.$model) = $event))
                }, null, 2), [
                  [
                    _vModelText,
                    _unref(v$).name.$model,
                    void 0,
                    { trim: true }
                  ]
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("label", {
                  for: "user-surname-input",
                  class: _normalizeClass(["input-form-label", { 'p-error': _unref(v$).surname.$invalid && submitted.value }])
                }, _toDisplayString(_unref(t)("common.surname")), 3),
                _withDirectives(_createElementVNode("input", {
                  id: "user-surname-input",
                  type: "text",
                  class: _normalizeClass(["input-form", {
                  'p-invalid': _unref(v$).surname.$invalid && submitted.value,
                }]),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).surname.$model) = $event))
                }, null, 2), [
                  [
                    _vModelText,
                    _unref(v$).surname.$model,
                    void 0,
                    { trim: true }
                  ]
                ])
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("label", _hoisted_6, _toDisplayString(_unref(t)('profile.phone')), 1),
              _withDirectives(_createElementVNode("input", {
                id: "user-phone-input",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(state).phone) = $event)),
                class: "input-form",
                type: "tel",
                inputmode: "tel",
                autocomplete: "tel",
                maxlength: "32",
                placeholder: "+7 701 123 45 67"
              }, null, 512), [
                [_vModelText, _unref(state).phone]
              ]),
              (submitted.value && !_unref(phoneValid))
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_unref(t)('profile.phoneInvalid')), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(t)("profile.middleName")), 1),
                _withDirectives(_createElementVNode("input", {
                  id: "user-middle-name-input",
                  type: "text",
                  class: "input-form",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(v$).middleName.$model) = $event))
                }, null, 512), [
                  [
                    _vModelText,
                    _unref(v$).middleName.$model,
                    void 0,
                    { trim: true }
                  ]
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("label", {
                  for: "user-login-input",
                  class: _normalizeClass(["input-form-label", { 'p-error': _unref(v$).login.$invalid && submitted.value }])
                }, _toDisplayString(_unref(t)("profile.login")), 3),
                _withDirectives(_createElementVNode("input", {
                  id: "user-login-input",
                  type: "text",
                  class: _normalizeClass(["input-form", {
                  'p-invalid': _unref(v$).login.$invalid && submitted.value,
                }]),
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(v$).login.$model) = $event))
                }, null, 2), [
                  [
                    _vModelText,
                    _unref(v$).login.$model,
                    void 0,
                    { trim: true }
                  ]
                ]),
                (_unref(v$).login.$externalResults.length > 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_unref(v$).login.$externalResults[0].$message), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", null, [
                _createElementVNode("label", {
                  for: "user-email-input",
                  class: _normalizeClass(["input-form-label", { 'p-error': _unref(v$).email.$invalid && submitted.value }])
                }, " Email ", 2),
                _withDirectives(_createElementVNode("input", {
                  id: "user-email-input",
                  type: "text",
                  class: _normalizeClass(["input-form", {
                  'p-invalid': _unref(v$).email.$invalid && submitted.value,
                }]),
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(v$).email.$model) = $event))
                }, null, 2), [
                  [_vModelText, _unref(v$).email.$model]
                ]),
                (_unref(v$).email.$externalResults.length > 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_unref(v$).email.$externalResults[0].$message), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("label", {
                  for: "user-password-input",
                  class: _normalizeClass(["input-form-label", { 'p-error': _unref(v$).password.$invalid && submitted.value }])
                }, _toDisplayString(_unref(t)("profile.password")), 3),
                _withDirectives(_createElementVNode("input", {
                  id: "user-password-input",
                  type: "password",
                  class: _normalizeClass(["input-form", {
                  'p-invalid': _unref(v$).password.$invalid && submitted.value,
                }]),
                  autocomplete: "new-password",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(v$).password.$model) = $event))
                }, null, 2), [
                  [_vModelText, _unref(v$).password.$model]
                ]),
                (_unref(v$).password.$error && submitted.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_unref(t)("docForm.fieldRequired")), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("label", {
                for: "user-iin-input",
                class: _normalizeClass(["input-form-label", { 'p-error': _unref(v$).iin.$invalid && submitted.value }])
              }, _toDisplayString(_unref(t)("common.iin")), 3),
              _withDirectives(_createElementVNode("input", {
                id: "user-iin-input",
                type: "text",
                class: _normalizeClass(["input-form", {
                'p-invalid': _unref(v$).iin.$invalid && submitted.value,
              }]),
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(v$).iin.$model) = $event))
              }, null, 2), [
                [
                  _vModelText,
                  _unref(v$).iin.$model,
                  void 0,
                  { trim: true }
                ]
              ]),
              (_unref(v$).iin.$error)
                ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_unref(t)("userForm.iinError")), 1))
                : _createCommentVNode("", true),
              (_unref(v$).iin.$externalResults.length > 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_unref(v$).iin.$externalResults[0].$message), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", null, [
                _createElementVNode("label", {
                  class: _normalizeClass([{
                  'p-error': _unref(v$).company.$invalid && submitted.value,
                }, "block text-sm"])
                }, _toDisplayString(_unref(t)("common.company")), 3),
                _createElementVNode("input", {
                  class: _normalizeClass(["input-form w-full cursor-pointer", {
                  'p-invalid': _unref(v$).company.$invalid && submitted.value,
                }]),
                  type: "text",
                  value: _unref(companyName),
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (isShowCompanyModal.value = true)),
                  readonly: ""
                }, null, 10, _hoisted_19)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("label", {
                  for: "job-select",
                  class: _normalizeClass(["input-form-label", { 'p-error': _unref(v$).job.$invalid && submitted.value }])
                }, _toDisplayString(_unref(t)("common.job")), 3),
                _withDirectives(_createElementVNode("select", {
                  id: "job-select",
                  class: _normalizeClass(["input-form w-full", {
                  'p-invalid': _unref(v$).job.$invalid && submitted.value,
                }]),
                  name: "job",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(v$).job.$model) = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jobs.value, (job) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: job.id,
                      key: job.id
                    }, _toDisplayString(job.name), 9, _hoisted_20))
                  }), 128))
                ], 2), [
                  [_vModelSelect, _unref(v$).job.$model]
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("label", {
                  for: "role-select",
                  class: _normalizeClass(["input-form-label", { 'p-error': _unref(v$).roleIds.$invalid && submitted.value }])
                }, _toDisplayString(_unref(t)("common.role")), 3),
                _createVNode(_unref(Multiselect), {
                  id: "role-select",
                  mode: "tags",
                  object: false,
                  class: _normalizeClass({
                  'p-invalid': _unref(v$).roleIds.$invalid && submitted.value,
                }),
                  modelValue: _unref(v$).roleIds.$model,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(v$).roleIds.$model) = $event)),
                  options: roles.value,
                  valueProp: "id",
                  "track-by": "name",
                  label: "name"
                }, null, 8, ["class", "modelValue", "options"])
              ]),
              (!_unref(isCreateMode))
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createElementVNode("span", {
                      class: _normalizeClass({ 'p-error': _unref(v$).status.$invalid && submitted.value })
                    }, _toDisplayString(_unref(t)("userForm.userStatus")), 3),
                    _createVNode(_unref(SegmentedButtons), {
                      class: _normalizeClass(["ml-10", {
                  'p-invalid': _unref(v$).status.$invalid && submitted.value,
                }]),
                      options: _unref(statuses),
                      modelValue: _unref(selectedStatus),
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_isRef(selectedStatus) ? (selectedStatus).value = $event : null))
                    }, null, 8, ["class", "options", "modelValue"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_22, _toDisplayString(_unref(t)("userForm.userType")), 1),
                _withDirectives(_createElementVNode("select", {
                  class: "input-form",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(v$).userType.$model) = $event))
                }, [
                  _createElementVNode("option", _hoisted_23, _toDisplayString(_unref(t)("userForm.userTypeInternal")), 1),
                  _createElementVNode("option", _hoisted_24, _toDisplayString(_unref(t)("userForm.userTypeExternal")), 1)
                ], 512), [
                  [_vModelSelect, _unref(v$).userType.$model]
                ])
              ])
            ])
          ]),
          _createVNode(EntityScopeFields, {
            modelValue: scopeFields.value,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((scopeFields).value = $event)),
            "directorate-options": _unref(directorateOptions)
          }, null, 8, ["modelValue", "directorate-options"]),
          _createVNode(_unref(Button), { type: "submit" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("userForm.save")), 1)
            ]),
            _: 1
          })
        ])
      ], 32),
      _createVNode(Modal, {
        show: isShowCompanyModal.value,
        onClose: _cache[18] || (_cache[18] = ($event: any) => (isShowCompanyModal.value = false)),
        title: _unref(t)('common.companies')
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_25, [
            _createVNode(TreeListMulti, {
              items: _unref(companies),
              "active-id": _unref(v$).company.$model,
              onSelect: _cache[15] || (_cache[15] = ($event: any) => (_unref(v$).company.$model = $event.id)),
              "parent-column": "parentId"
            }, null, 8, ["items", "active-id"])
          ]),
          _createVNode(_unref(Button), {
            onClick: _cache[16] || (_cache[16] = ($event: any) => (isShowCompanyModal.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("common.confirm")), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Button), {
            class: "ml-2",
            onClick: _cache[17] || (_cache[17] = ($event: any) => {
          _unref(v$).company.$model = null;
          isShowCompanyModal.value = false;
        })
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("common.clear")), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["show", "title"])
    ])
  ], 64))
}
}

})